webpackJsonp([15],{

/***/ 123:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABl0lEQVRIS8WV0VECQQyGk1CAWIHs7L6LHUAFQgXSgVKBUoFagdgBVCAlUMDtLCVgAWycnHczcLd7e4fDmNfN5UvyJzmECxteOD60Bjjnht77e0mImXe9Xm+tlNqnEkwCisAfADCsBNsz89wYs2yCNAKK4F8A0G8I8q61foq9NwKstTsAuEm1gYjGSqlNyC8KyLJshojSmqQx88YYM+4KWCLiQzJ64UBE1yHRoxVYa7cAcNsWwMxTY8yq6h8EOOdG3nsRt7XF2hQEWGtfAOC5dfRfx2+tdW3agoAsy1aImC9VB9sR0V1VhxrgzOzzPJj50xgzO07qBOCc63vvXWKxGosiIqWUkv3J7QTQZfYbKHOt9VsQ8Jf2iMgAcAUAC621DEm0AqGLw2sHgaX/U0RcMvPseB9qIjvnBtLDLovGzGtjzKT8Nipy+VCILXsQvZKV6t6IaNH6VJyzB2UV1bbGNll0eKw6y5znoxc+gsH/QvTYST8Ph8MIEQcAsCeiVTnf8ua9n8i+FL/PrVJKjmPNkr/MLpP0L4AfTF+3GbapIJIAAAAASUVORK5CYII="

/***/ }),

/***/ 124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__(233);




var config = {
  env: __WEBPACK_IMPORTED_MODULE_0__env__["a" /* default */]
};

config.mode = 'history';
if (__WEBPACK_IMPORTED_MODULE_0__env__["a" /* default */] == 'development') {
  config.api = 'http://www.gjypzc.cn/api';
} else {
  config.api = 'http://www.gjypzc.cn/api';
}
/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),

/***/ 183:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABv0lEQVRIS+2U0ZHTMBCG/10XwJWAR3onVECogLsKLlcBuQo4OkgH5CogVAAdAO/WKCUkBUQ/sx4p4/gcOzfDvTDoxZYs7ef/39UKXnjIC8fHPwqIMV6llG5JXovIPNu4JbkVkY2qPtZ1vbvE3icWhRCWAD4BuBoJsCN5771fT0FOAE3TrEXkFsAewAqAwV7lIENrn51zD2OQI6BpGrPja97cHgwh2GFTY2NoDar6tq7rX+cgXcBGRD7kjeZvUVCsKms3JFdVVf2o63p7sUUhBE5tBnCvqhsrAADXAGb5jCkoyT+BHhVMAUjeAdiJyJeRArDk33nvN+Vnz1l0Iobkt6qqHlJKP+2Dze1ZLO3Pu3k5AmKM85TS9yGbSN4AWJSAzrn2XFHdnxvQe28WnraKEIIl9mMfYgG6FpJsLRCRNkh/bmsFOnTRuqXZsvqAC4ph75xrq28IYCoWANYkZyLyTlXfHw6HZaeMRxkkH733FmMYoKqrfo3HGGclyRMK9qo6L5fvWe0633brP6V99Fl7kovBMr3A13ZLjPF1SsnkW4Lf5HO/8/uT3vQsBWM/kcFL55w1yOP4a4Bz8P+Aydr4A+xX1RkPlrv1AAAAAElFTkSuQmCC"

/***/ }),

/***/ 184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var routes = [{
    path: '/',
    name: '首页',
    component: function component(resolve) {
        __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(501)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/index',
    component: function component(resolve) {
        __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(498)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/statute',
    name: '法规中心',
    component: function component(resolve) {
        __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(506)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/statute-content',
    name: '',
    component: function component(resolve) {
        __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(507)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/news',
    name: '新闻资讯',
    component: function component(resolve) {
        __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(502)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/news-content',
    name: '',
    component: function component(resolve) {
        __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(503)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/business',
    name: '业务服务',
    component: function component(resolve) {
        __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(499)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/codex',
    name: '数据库',
    component: function component(resolve) {
        __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(500)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/questions',
    name: '问与答',
    component: function component(resolve) {
        __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(505)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/questions-content',
    name: '',
    component: function component(resolve) {
        __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(504)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/term',
    name: '术语学习',
    component: function component(resolve) {
        __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(509)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/term-content',
    component: function component(resolve) {
        __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(508)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/about',
    component: function component(resolve) {
        __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(510)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: '/personal',
    component: function component(resolve) {
        __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(511)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}];
/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return $http; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config_js__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_js__ = __webpack_require__(58);





var $http = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
    baseURL: __WEBPACK_IMPORTED_MODULE_2__config_config_js__["a" /* default */].api,
    timeout: 5000
});

$http.interceptors.request.use(function (config) {
    config.headers.common['Authorization'] = 'Bearer' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__auth_js__["c" /* getToken */])();
    return config;
}, function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

$http.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response) {
        if (error.response.status == 401) {
            console.log(error);
        }

        if (error.response.status == 402) {
            console.log(error);
        }
    } else {}
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});


/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_auth_js__ = __webpack_require__(58);




__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */]);
var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */].Store({
    state: {
        member: {},

        mainLoading: false,
        lawData: {},
        loginState: false,
        regState: false,
        forgotState: false,
        token: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_auth_js__["c" /* getToken */])()
    },
    mutations: {
        SET_USER_INFO: function SET_USER_INFO(state, userinfo) {
            state.member = userinfo;
        },
        mainLoading: function mainLoading(state, show) {
            state.mainLoading = show;
        },

        SET_LAW: function SET_LAW(state, list) {
            state.lawData = list;
        },
        SET_LOGIN_STATE: function SET_LOGIN_STATE(state, status) {
            state.loginState = status;
        },
        SET_REG_STATE: function SET_REG_STATE(state, status) {
            state.regState = status;
        },
        SET_FORGOT_STATE: function SET_FORGOT_STATE(state, status) {
            state.forgotState = status;
        },
        SET_TOKEN: function SET_TOKEN(state, token) {
            state.token = token;
        }
    },
    getters: {
        member: function member(state) {
            return state.member;
        },
        categoryList: function categoryList(state) {
            return state.lawData;
        }
    },
    actions: {
        setUserInfo: function setUserInfo(_ref, userinfo) {
            var commit = _ref.commit,
                state = _ref.state;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                commit('SET_USER_INFO', userinfo);
                resolve();
            });
        },
        setLawList: function setLawList(_ref2, data) {
            var commit = _ref2.commit,
                state = _ref2.state;

            commit('SET_LAW', data);
        },

        login: function login(_ref3, status) {
            var commit = _ref3.commit;

            commit('SET_LOGIN_STATE', status);
        },
        changeRegState: function changeRegState(_ref4, status) {
            var commit = _ref4.commit;

            commit('SET_REG_STATE', status);
        },
        forgot: function forgot(_ref5, status) {
            var commit = _ref5.commit;

            commit('SET_FORGOT_STATE', status);
        },
        setToken: function setToken(_ref6, token) {
            var commit = _ref6.commit;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                commit('SET_TOKEN', token);
                resolve();
            });
        }
    }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 188:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 189:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(493),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showBackTop: false,
            v1: false,
            v2: false,
            v3: false,
            v4: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        window.addEventListener('scroll', function (e) {
            _this.scrollToTop(e);
        });
    },

    methods: {
        scrollToTop: function scrollToTop(e) {
            var scrollTop = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).scrollTop();
            if (scrollTop > 100) {
                this.showBackTop = true;
            } else {
                this.showBackTop = false;
            }
        },
        backTop: function backTop() {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).scrollTop(0);
        }
    }
});

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ul_tree_vue__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ul_tree_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ul_tree_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_auth_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(89);






/* harmony default export */ __webpack_exports__["default"] = ({
    components: { ulTree: __WEBPACK_IMPORTED_MODULE_1__ul_tree_vue___default.a },
    data: function data() {
        return {
            link: [],
            curIndex: -1,
            trans_in: false,
            depth0: false,
            open: false,
            isLogin: false,
            showUserName: false,
            searchIsReady: true,
            searchTarget: 'statute',
            keyword: ''
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['member', 'categoryList'])),
    mounted: function mounted() {
        var _this = this;

        var interval = setInterval(function (_) {
            if (_this.member.id) {
                _this.isLogin = true;
                clearInterval(interval);
            }
        }, 1000);
    },

    methods: {
        getLinkParam: function getLinkParam(link) {
            this.$router.push({ path: '/statute', query: { q: link.join('|') } });
        },
        toggle: function toggle(val) {
            this.trans_in = val;
        },
        login: function login() {
            this.$store.dispatch('login', true);
            this.trans_in = false;
        },
        showReg: function showReg() {
            this.$store.dispatch('changeRegState', true);
            this.trans_in = false;
        },
        quit: function quit() {
            var _this2 = this;

            this.$store.dispatch('setToken', '').then(function (_) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_auth_js__["b" /* removeToken */])();
                _this2.$router.go(0);
            });
        },
        search: function search() {
            if (!this.keyword) {
                return;
            } else {
                if (this.searchTarget == 'statute') {
                    this.$router.push({ path: '/statute', query: { s: this.keyword } });
                } else {
                    this.$router.push({ path: '/news', query: { s: this.keyword } });
                }
            }
        }
    }
});

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ul-tree',
    props: {
        data: Object
    },
    data: function data() {
        return {
            open: false,
            selectedContainer: []
        };
    },
    computed: {
        isFolder: function isFolder() {
            return this.data.children && this.data.children.length;
        }
    },
    methods: {
        toggle: function toggle(name, id, children, depth) {
            if (this.isFolder) {
                this.open = !this.open;
            }
            if (name == '法律法规') return;
            this.selectedContainer[depth] = id;
            if (!children) {
                this.$emit('transform', false);
                for (var x = depth; x < this.categoryDepth; x++) {
                    this.selectedContainer.splice(x + 1, this.selectedContainer.length - x + 1);
                }
                this.$router.push({ path: '/statute', query: { q: this.selectedContainer.join('|') } });
            }
        }
    }
});

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_vue__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_footer_vue__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_user_login_vue__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_user_login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_user_login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_user_forgot_vue__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_user_forgot_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_user_forgot_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_user_register_vue__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_user_register_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_user_register_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_affix_vue__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_affix_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_affix_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        headerView: __WEBPACK_IMPORTED_MODULE_0__components_header_vue___default.a,
        footerView: __WEBPACK_IMPORTED_MODULE_1__components_footer_vue___default.a,
        login: __WEBPACK_IMPORTED_MODULE_2__pages_user_login_vue___default.a,
        register: __WEBPACK_IMPORTED_MODULE_4__pages_user_register_vue___default.a,
        forgot: __WEBPACK_IMPORTED_MODULE_3__pages_user_forgot_vue___default.a,
        affix: __WEBPACK_IMPORTED_MODULE_6__components_affix_vue___default.a
    },
    data: function data() {
        return {
            loading: false,
            user_id: '',
            depth: 0,
            categoryList: []
        };
    },

    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
        spinShow: 'mainLoading',
        login: 'loginState',
        reg: 'regState',
        token: 'token',
        forgot: 'forgotState'
    }),
    mounted: function mounted() {
        this.getCarousel();
        if (this.token) {
            this.getAuth();
        }
    },

    methods: {
        getAuth: function getAuth() {
            var _this = this;

            this.$http.get('/member/me?include=statute,term,questions&fe=1').then(function (res) {
                _this.$store.dispatch('setUserInfo', res.data.data);
            }).catch(function (err) {
                _this.$Notice.open({
                    title: '请登录..'
                });
            });
        },
        getCarousel: function getCarousel() {
            var _this2 = this;

            this.$http.get('/category/list', {
                params: {
                    include: "childrens.childrens.childrens",
                    fe: 1
                }
            }).then(function (res) {
                _this2.categoryList = res.data.data;
                _this2.getTree(_this2.categoryList);
                _this2.$store.dispatch('setLawList', {
                    depth: _this2.depth + 1,
                    name: '注册法规',
                    children: _this2.categoryList
                });
            }).catch(function (err) {
                _this2.$Notice.open({
                    title: 'category'
                });
            });
        },
        getTree: function getTree(node) {
            var _this3 = this;

            if (node && node.length != 0) {
                node.forEach(function (item, index) {
                    item.label = item.name;
                    item.value = item.id;
                    _this3.depth = _this3.depth > item.depth ? _this3.depth : item.depth;
                    if (item.childrens) {
                        item.children = item.childrens.data;
                        _this3.getTree(item.childrens.data);
                        delete item.childrens;
                    }
                });
            }
        }
    }
});

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        var validatePassCheck = function validatePassCheck(rule, value, callback) {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== _this.form.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            form: {},
            disabled: false,
            codeText: '获取验证码',
            rules: {
                phone: [{ required: true, pattern: /^((0\d{2,3}\d{7,8})|(1[35874]\d{9}))$/, message: '请输入正确的账号', trigger: 'blur' }],
                code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }, { type: 'string', min: 6, max: 20, message: '密码长度在6~16位之间', trigger: 'blur' }],
                passwdCheck: [{ validator: validatePassCheck, trigger: 'blur' }]
            }
        };
    },

    methods: {
        getPassword: function getPassword(name) {
            var _this2 = this;

            this.$refs[name].validate(function (valid) {
                if (valid) {
                    _this2.$http.post('/member/forgetPassword', {
                        code: _this2.form.code,
                        password: _this2.form.password,
                        phone: _this2.form.phone,
                        fe: 1
                    }).then(function (res) {
                        var data = res.data;
                        if (data.status_code == 200) {
                            _this2.$store.dispatch('forgot', false);
                            _this2.$store.dispatch('login', true);
                            _this2.$Notice.success({
                                title: '修改成功'
                            });
                        }
                    }).catch(function (err) {});
                }
            });
        },
        close: function close() {
            this.$store.dispatch('forgot', false);
        },
        login: function login() {
            this.$store.dispatch('forgot', false);
            this.$store.dispatch('login', true);
        },
        reg: function reg() {
            this.$store.dispatch('changeRegState', true);
            this.$store.dispatch('forgot', false);
        },
        codeBtn: function codeBtn() {
            var _this3 = this;

            if (!/^((0\d{2,3}\d{7,8})|(1[35874]\d{9}))$/.test(this.form.phone)) {
                this.$Notice.warning({
                    title: '请输入正确的手机号'
                });
                return;
            }
            var sec = 60;
            for (var i = 0; i <= 60; i++) {
                var that = this;
                setTimeout(function () {
                    if (sec != 0) {
                        that.codeText = sec + "秒后重发验证";
                        that.disabled = true;
                        sec--;
                    } else {
                        sec = 60;
                        that.disabled = false;
                        that.codeText = "获取验证码";
                    }
                }, i * 1000);
            }
            this.$http.post('http://www.gjypzc.cn/sendForgetPasswordMsg', {
                phone: this.form.phone,
                fe: 1
            }).then(function (ret) {
                _this3.testCode = ret.data.code;
                _this3.$Notice.success({ title: '获取验证码成功' });
            }).catch(function (err) {
                _this3.$Notice.error({ title: '获取验证码失败..' });
            });
        }
    }
});

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_auth_js__ = __webpack_require__(58);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            form: {
                email: null,
                password: null,
                status: 'SHIP'
            },

            rules: {
                phone: [{
                    required: true,
                    pattern: /^((0\d{2,3}\d{7,8})|(1[35874]\d{9}))$/,
                    message: '请输入正确的账号',
                    trigger: 'blur,change'
                }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
            }
        };
    },

    methods: {
        created: function created() {
            var index = location.search.indexOf('=');
            if (index > 0) {
                var token = location.search.substr(index + 1);
                window.localStorage.setItem('ccm-token', token);
            }
        },
        weixin_login: function weixin_login() {
            var _this = this;

            this.$http.get('/wechatUrl').then(function (response) {
                location.href = response.data.url;
                sessionStorage['source_url'] = _this.$route.fullPath;
            }).catch(function (error) {});
        },
        qq_login: function qq_login() {
            var _this2 = this;

            this.$http.get('/qqUrl').then(function (response) {
                location.href = response.data.url;
                sessionStorage['source_url'] = _this2.$route.fullPath;
            }).catch(function (error) {});
        },
        doLogin: function doLogin() {
            var _this3 = this;

            this.$refs['login-form'].validate(function (valid) {
                if (valid) {
                    _this3.$http.get('member/oauth', {
                        params: _this3.form
                    }).then(function (response) {
                        _this3.$store.dispatch('setToken', response.data.token).then(function (_) {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_auth_js__["a" /* setToken */])(response.data.token);
                        });
                        _this3.$Notice.success({ title: '登录成功' });

                        location.href = location.href;
                    }).catch(function (error) {
                        _this3.$Notice.error({
                            desc: '账号或密码错误，或者管理员未审核该账号！'
                        });
                    });
                }
            });
        },
        closeLogin: function closeLogin() {
            this.$store.dispatch('login', false);
        },
        forgot: function forgot() {
            this.$store.dispatch('login', false);
            this.$store.dispatch('changeRegState', false);
            this.$store.dispatch('forgot', true);
        },
        reg: function reg() {
            this.$store.dispatch('changeRegState', true);
            this.$store.dispatch('login', false);
        }
    }
});

/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_auth_js__ = __webpack_require__(58);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        var validatePassCheck = function validatePassCheck(rule, value, callback) {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== _this.form.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {

            usernamer: '',
            password: '',
            code: '',
            testCode: '',
            disabled: false,
            codeText: '获取验证码',
            form: {
                name: '',
                phone: '',
                password: '',
                code: ''
            },
            rules: {
                phone: [{ required: true, pattern: /^((0\d{2,3}\d{7,8})|(1[35874]\d{9}))$/, message: '请输入正确的账号', trigger: 'blur,change' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }, { type: 'string', min: 6, max: 20, message: '密码长度在6~16位之间', trigger: 'blur' }],
                passwdCheck: [{ validator: validatePassCheck, trigger: 'blur' }]
            }
        };
    },

    methods: {
        registerBtn: function registerBtn() {
            var _this2 = this;

            this.$refs['login-form'].validate(function (valid) {

                if (valid) {
                    _this2.$http.post('member/add', {
                        name: _this2.form.name,
                        password: _this2.form.password,
                        phone: _this2.form.phone,
                        code: _this2.form.code,
                        fe: 1
                    }).then(function (response) {

                        _this2.$Notice.success({
                            title: '注册成功！'
                        });
                        _this2.$http.get('member/oauth', {
                            params: {
                                phone: _this2.form.phone,
                                password: _this2.form.password,
                                status: 'SHIP'
                            }
                        }).then(function (response) {
                            _this2.$store.dispatch('setToken', response.data.token).then(function (_) {
                                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_auth_js__["a" /* setToken */])(response.data.token);
                            });

                            _this2.$router.go(0);
                        }).catch(function (error) {
                            _this2.$Notice.error({
                                title: '账号或密码错误，或者管理员未审核该账号！'
                            });
                        });
                    }).catch(function (error) {
                        var err = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error);
                        err = JSON.parse(err);
                        var e = '';
                        var errors = err.response.data.errors;
                        for (var value in errors) {
                            e += errors[value][0] + '<br/>';
                        }
                        _this2.$Notice.error({
                            title: '注册失败',
                            desc: e
                        });
                    });
                }
            });
        },
        codeBtn: function codeBtn() {
            var _this3 = this;

            if (!/^((0\d{2,3}\d{7,8})|(1[35874]\d{9}))$/.test(this.form.phone)) {
                this.$Notice.warning({ title: '请输入正确的手机号' });
                return;
            }
            var sec = 60;
            for (var i = 0; i <= 60; i++) {
                var that = this;
                window.setTimeout(function () {
                    if (sec != 0) {
                        that.codeText = sec + "秒后重发验证";
                        that.disabled = true;
                        sec--;
                    } else {
                        sec = 60;
                        that.disabled = false;
                        that.codeText = "获取验证码";
                    }
                }, i * 1000);
            }
            this.$http.post('http://www.gjypzc.cn/sendMsg', { phone: this.form.phone }).then(function (ret) {

                _this3.testCode = ret.data.code;

                _this3.$Notice.success({ title: '获取验证码成功' });
            }).catch(function (err) {

                _this3.$Notice.error({ title: '获取验证码失败..' });
            });
        },
        toLogin: function toLogin() {
            this.$store.dispatch('login', true);
            this.closeReg();
        },
        closeReg: function closeReg() {
            this.$store.dispatch('changeRegState', false);
        }
    }
});

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ("development");

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes_index_js__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuex_store_js__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_iview__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_iview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_config_js__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_iview_dist_styles_iview_css__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_iview_dist_styles_iview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_iview_dist_styles_iview_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_css_main_css__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_css_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_css_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_fetch_js__ = __webpack_require__(185);











__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_iview___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

"use strict";
var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
    routes: __WEBPACK_IMPORTED_MODULE_4__routes_index_js__["a" /* default */],
    mode: __WEBPACK_IMPORTED_MODULE_7__config_config_js__["a" /* default */].mode
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_10__utils_fetch_js__["a" /* $http */];


new __WEBPACK_IMPORTED_MODULE_1_vue__["default"](__WEBPACK_IMPORTED_MODULE_1_vue__["default"].util.extend({ router: router, store: __WEBPACK_IMPORTED_MODULE_5__vuex_store_js__["a" /* default */] }, __WEBPACK_IMPORTED_MODULE_3__App___default.a)).$mount('#app');

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 466:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 467:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 468:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 469:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 470:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 471:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 474:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABrklEQVRIS92VuU7DQBCG/1k/APACkGi35hA8QGgBATUN0FFyFJSIkoKjpAMaWg5BDfQggWi9SniD5AF2Bo1lRw5JMEfSxN1e3+f9d7wm9PmhPvMxIALv/QKA6R7H9WKtvUsi8t7XAdwDWOmR5BLAnLV2JBMIAJUcA9gGMPRHUQPAEYAtAMPWWsoLlFk3xmww8wGAsV9KPowxu8x8qnBd20mQSIhokZl3iGjpJxIRuTHGHIrIbQb/TpBIRGSdiCYB7BVI9kXklYjO8vAiQcJUSbqj8w7n0hCRNYWm8Lb36BZRc6KIPDnnKtVqtcTM1wAm0sE3Y8xyuVyuee9fc/0tkiKBQiq6IoRQiaLoMYRwou0oijazPm0zs0raiuI7QSODM/ODxqBxOec0KsRxvJbGolU3m0oev8bYVZAuqmfwbN/pmeBL5okkhFAioqt8Rh0FXSCF1ZpWnda/fqzJ0yYQkQsi0jybkwrJrRM2RWSKiFbbBFoxAGrZ4C/B+el6TlNaWc0dxHH8DuCDiOb/Ac6Xt16c48650ewu0ut6phfwHOO5eV33GNyCG5BfZj8j+gRMTtEZ3JgYIAAAAABJRU5ErkJggg=="

/***/ }),

/***/ 475:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACF0lEQVRIS5VV7VEcMQyV1ACkgpxH/s9RQS4VBCqAEkIFIRWEdAAVQCoIqSDHf+8YKsjRgJXRjnXj9e567/Rrxyvr40nvGWHBYoynKaUrALgGgHV23wLAPRE9OOd2rRDY+hljXKeUHgFgNeP3SkSXzjlNOGmzCXLlEQBOF5rcEZGb62Q2QQjhHhEVmt5E5A8iPuXvC0T8VPx78N4rhCObTJCr/1cE+OW9vyhvhxCeEPGLnTHzZKy5BJuU0m+7TETnNc55Pn8Ln8/Ouee6hUMTfKgxrrskoqMSrFJKOmDD/9J73+NvFkLQOeiG9UZEoyL0fHbIXdfp6p3l+4N1zPAohLZhL8xsHBmg1ErwFQB+VJjavtfBbpj57uAtUseM8SsAnExdLM7eiWh1NA80QNd1twDwbSHBd2ZWv0lbkgrVoVYXzeqbQ7ZyFrpoVn9QggyVdvGxwuCNmedEcO/ahMi8YowDZue9nyRWPYiDEuilUntEZKRNRw05xmit72z9irVV1u7XUs+NcM45hXKeaDmIkkuZOSKOyoPermUjz0mJeUZENyUnBhCZPIjISHsWuKAQmjZtmfnc/PcJKvnVd/aWmX8uBS6qV0L22lTK+6CDEMJz+VKps4joWa/zRNRrUUqp1yIR2SDipixCXz7v/f5stEWZWIrnkgbVzb0DwF0tG603WTFd5yq1dZNuC/wiIjvtTkS2U4NXx/9M9RgoSTun/AAAAABJRU5ErkJggg=="

/***/ }),

/***/ 476:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABr0lEQVRIS81W7VHCQBC93RQAHcjOXQFagViBWIFQgVqBUIFQgbECQwViB/D/boId0AC3zmYSJsZ8SO6PN5Nkksy+l9vd9zag8mWtnQLAg1LqkpmTKIpmRHQo3ve9ggRaa2MAuC+DMPObMWbaF7iIA2vtBADe64AQkYhoH0IiBBsAuG4AWWmtH4MInHPcArDXWlMogRRy0ASCiFdEtO1L0pUixcwzY0z8rwkSALht+MIdIo5D9CApEoG9Vgi+lFJLRIxDwAUT0jQdee/T6g601pkIQ1cG4pwTMV1UlBxU3JOSc4KlUkp8qLyCNZClSE5pmg6997KLqh4WWut5SJpOeXbOCdBzFQwRb4ho05fkRNCyiwMi3tWR5DGZCyPilog+qx/yo1MaWraImWutF8VNDv4h86MEKraTIOKqsJdfreicqyt4gbFn5nkURWvvvcyKl5bUxYj4VNvrdQOoBkiaYtRWG2ZeN4qpqejnFrtVrXlNJGWNdt5BuOu0g7yYMtXkOItIrL6ToNI1opVJ1VbqdlH8NPyZoAwiBnk8Hsc52TCzBABp1wEzixaWxphEnn8Dp5TB+8ZmroUAAAAASUVORK5CYII="

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qrcode.4863d3e.png";

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qrcode2.9cc35f8.png";

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(465)

var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(486),
  /* scopeId */
  "data-v-210d6d6a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(470)

var Component = __webpack_require__(33)(
  /* script */
  null,
  /* template */
  __webpack_require__(491),
  /* scopeId */
  "data-v-68f0dba0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(466)

var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(487),
  /* scopeId */
  "data-v-268c13bc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(468)

var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(489),
  /* scopeId */
  "data-v-4bd377fe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(467)

var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(488),
  /* scopeId */
  "data-v-428638d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(471)

var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(492),
  /* scopeId */
  "data-v-7b7962f8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(469)

var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(490),
  /* scopeId */
  "data-v-54df0bd8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "affix"
  }, [_c('div', {
    staticClass: "affix-wrapper"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBackTop),
      expression: "showBackTop"
    }],
    staticClass: "affix-item back-to-top",
    on: {
      "click": _vm.backTop,
      "mouseenter": function($event) {
        _vm.v1 = true;
      },
      "mouseleave": function($event) {
        _vm.v1 = false;
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "chevron-up"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.v1),
      expression: "v1"
    }],
    staticClass: "drop-out"
  }, [_c('p', [_vm._v("返回顶部")])])])], 1), _vm._v(" "), _c('a', {
    staticClass: "affix-item qq-contact",
    attrs: {
      "target": "_blank",
      "href": "http://wpa.qq.com/msgrd?v=3&uin=276481348&site=qq&menu=yes",
      "title": "商务合作",
      "alt": "商务合作"
    },
    on: {
      "mouseenter": function($event) {
        _vm.v2 = true;
      },
      "mouseleave": function($event) {
        _vm.v2 = false;
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(123)
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.v2),
      expression: "v2"
    }],
    staticClass: "drop-out"
  }, [_vm._v("商务合作")])])], 1), _vm._v(" "), _c('a', {
    staticClass: "affix-item qq-contact",
    attrs: {
      "target": "_blank",
      "href": "http://wpa.qq.com/msgrd?v=3&uin=3281935475&site=qq&menu=yes",
      "alt": "业务咨询",
      "title": "业务咨询"
    },
    on: {
      "mouseenter": function($event) {
        _vm.v3 = true;
      },
      "mouseleave": function($event) {
        _vm.v3 = false;
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(123)
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.v3),
      expression: "v3"
    }],
    staticClass: "drop-out"
  }, [_vm._v("业务咨询")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "affix-item wechat-contact",
    on: {
      "mouseenter": function($event) {
        _vm.v4 = true;
      },
      "mouseleave": function($event) {
        _vm.v4 = false;
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(183)
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "scale"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.v4),
      expression: "v4"
    }],
    staticClass: "drop-out"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(478),
      "width": "150",
      "alt": "关注我们",
      "title": "关注我们"
    }
  })])])], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 487:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header clearfix"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "login hide-in-mobile"
  }, [(!_vm.isLogin) ? _c('a', {
    staticClass: "log",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.login
    }
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v("登录")]) : _vm._e(), _vm._v(" "), (!_vm.isLogin) ? _c('a', {
    staticClass: "reg",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.showReg
    }
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v("注册")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "person hide-in-mobile"
  }, [(_vm.isLogin) ? _c('Dropdown', {
    attrs: {
      "trigger": "click"
    }
  }, [_c('a', {
    staticClass: "name",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.member.name) + "   "), _c('Icon', {
    attrs: {
      "type": "arrow-down-b"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', [_c('router-link', {
    attrs: {
      "to": "/personal"
    }
  }, [_vm._v("个人中心")])], 1), _vm._v(" "), _c('DropdownItem', [_c('a', {
    on: {
      "click": _vm.quit
    }
  }, [_vm._v("退出")])])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "search hide-in-mobile"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchIsReady),
      expression: "searchIsReady"
    }],
    staticClass: "search-target",
    staticStyle: {
      "width": "74px"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.searchTarget),
      callback: function($$v) {
        _vm.searchTarget = $$v
      },
      expression: "searchTarget"
    }
  }, [_c('Option', {
    attrs: {
      "value": "statute"
    }
  }, [_vm._v("法规")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "news"
    }
  }, [_vm._v("新闻")])], 1)], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "search-ipt",
    class: {
      'is-active': _vm.searchIsReady
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "search-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.search
    }
  }, [_c('Icon', {
    attrs: {
      "type": "search",
      "size": "20",
      "color": "#15ccac"
    }
  })], 1)], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [(_vm.$route.path == '/') ? _c('h1', [_vm._v("国际药品注册网")]) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.$route.path != '/' ? '国际药品注册网' : '') + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "nav hide-in-mobile"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', {
    class: {
      'is-active': _vm.$route.path == '/'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('li', {
    staticClass: "cascader",
    class: {
      'is-active': _vm.$route.path == '/statute'
    }
  }, [_c('Cascader', {
    attrs: {
      "data": _vm.categoryList.children,
      "trigger": "hover"
    },
    on: {
      "on-change": _vm.getLinkParam
    },
    model: {
      value: (_vm.link),
      callback: function($$v) {
        _vm.link = $$v
      },
      expression: "link"
    }
  }, [_c('a', [_vm._v("注册法规")])])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-active': (_vm.$route.path == '/questions' || _vm.$route.path == '//term-content')
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/questions'
      }
    }
  }, [_vm._v("问与答")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-active': (_vm.$route.path == '/term' || _vm.$route.path == '/term-content')
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/term'
      }
    }
  }, [_vm._v("术语学习")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.$route.path == '/news'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/news'
      }
    }
  }, [_vm._v("新闻资讯")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.$route.path == '/business'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/business'
      }
    }
  }, [_vm._v("业务服务")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.$route.path == '/codex'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/codex'
      }
    }
  }, [_vm._v("数据库")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.curIndex == 7
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/about'
      }
    }
  }, [_vm._v("关于我们")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "hide hamburger show-in-mobile",
    on: {
      "click": function($event) {
        _vm.trans_in = true
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "navicon-round",
      "size": "20"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "search show-in-mobile"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchIsReady),
      expression: "searchIsReady"
    }],
    staticClass: "search-target",
    staticStyle: {
      "width": "74px"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.searchTarget),
      callback: function($$v) {
        _vm.searchTarget = $$v
      },
      expression: "searchTarget"
    }
  }, [_c('Option', {
    attrs: {
      "value": "statute"
    }
  }, [_vm._v("法规")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "news"
    }
  }, [_vm._v("新闻")])], 1)], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "search-ipt",
    class: {
      'is-active': _vm.searchIsReady
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "search-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.search
    }
  }, [_c('Icon', {
    attrs: {
      "type": "search",
      "size": "20",
      "color": "#15ccac"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "show-in-mobile"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.trans_in),
      expression: "trans_in"
    }],
    staticClass: "nav-layout",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.trans_in = false
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.trans_in) ? _c('div', {
    staticClass: "aside-nav"
  }, [(!_vm.isLogin) ? _c('div', {
    staticClass: "aside-login"
  }, [_c('Button', {
    attrs: {
      "type": "success",
      "long": ""
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "ghost",
      "long": ""
    },
    on: {
      "click": _vm.showReg
    }
  }, [_vm._v("注册")])], 1) : _vm._e(), _vm._v(" "), (_vm.isLogin) ? _c('div', {
    staticClass: "aside-login"
  }, [_c('Avatar', {
    staticStyle: {
      "color": "#fff",
      "background-color": "#15ccac",
      "margin": "0 auto",
      "display": "block"
    },
    attrs: {
      "size": "large"
    }
  }, [_vm._v(_vm._s(_vm.member.name))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/personal"
    }
  }, [_c('Button', {
    attrs: {
      "type": "success",
      "long": ""
    }
  }, [_vm._v("个人中心")])], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "ghost",
      "long": ""
    },
    on: {
      "click": _vm.quit
    }
  }, [_vm._v("退出")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "aside-menu"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('li', [_c('ul-tree', {
    staticClass: "aside-sub-nav-menu",
    attrs: {
      "data": _vm.categoryList
    },
    on: {
      "transform": _vm.toggle
    }
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/questions'
      }
    }
  }, [_vm._v("问与答")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/term'
      }
    }
  }, [_vm._v("术语学习")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/news'
      }
    }
  }, [_vm._v("新闻资讯")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/business'
      }
    }
  }, [_vm._v("业务服务")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/codex'
      }
    }
  }, [_vm._v("数据库")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/about'
      }
    }
  }, [_vm._v("关于我们")])], 1)])])]) : _vm._e()])], 1)])], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 488:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "close-window",
    on: {
      "click": _vm.close
    }
  }, [_c('Icon', {
    attrs: {
      "type": "close-round"
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('Form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone", $$v)
      },
      expression: "form.phone"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "code"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    model: {
      value: (_vm.form.code),
      callback: function($$v) {
        _vm.$set(_vm.form, "code", $$v)
      },
      expression: "form.code"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Button', {
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.codeBtn
    }
  }, [_vm._v(_vm._s(_vm.codeText))])], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入新密码"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "passwdCheck"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "再次确认密码"
    },
    model: {
      value: (_vm.form.passwdCheck),
      callback: function($$v) {
        _vm.$set(_vm.form, "passwdCheck", $$v)
      },
      expression: "form.passwdCheck"
    }
  })], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "success",
      "long": ""
    },
    on: {
      "click": function($event) {
        return _vm.getPassword('form')
      }
    }
  }, [_vm._v("找回密码")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "long": ""
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("已有账号？登录")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "long": ""
    },
    on: {
      "click": _vm.reg
    }
  }, [_vm._v("还没有账号？立即注册")])], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', {
    staticClass: "clearfix"
  }, [_c('span', [_vm._v("忘记密码")])])])
}]}

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ul-tree"
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.toggle(_vm.data.name, _vm.data.id, _vm.data.children, _vm.data.depth)
      }
    }
  }, [_vm._v(_vm._s(_vm.data.name)), (_vm.isFolder && _vm.data.children) ? _c('Icon', {
    attrs: {
      "type": _vm.open ? 'chevron-down' : 'chevron-right',
      "size": "12"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.isFolder) ? _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    staticClass: "aside-sub-nav-menu"
  }, _vm._l((_vm.data.children), function(item) {
    return _c('ul-tree', {
      key: item.id,
      attrs: {
        "data": item
      }
    })
  }), 1) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ 490:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "close-window",
    on: {
      "click": _vm.closeReg
    }
  }, [_c('Icon', {
    attrs: {
      "type": "close-round"
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('Form', {
    ref: "login-form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入用户名"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone", $$v)
      },
      expression: "form.phone"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "passwdCheck"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "请确认密码"
    },
    model: {
      value: (_vm.form.passwdCheck),
      callback: function($$v) {
        _vm.$set(_vm.form, "passwdCheck", $$v)
      },
      expression: "form.passwdCheck"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "code"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    model: {
      value: (_vm.form.code),
      callback: function($$v) {
        _vm.$set(_vm.form, "code", $$v)
      },
      expression: "form.code"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Button', {
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.codeBtn
    }
  }, [_vm._v(_vm._s(_vm.codeText))])], 1)], 1)], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "success",
      "long": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.registerBtn($event)
      }
    }
  }, [_vm._v(" 注 册 ")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "long": ""
    },
    on: {
      "click": _vm.toLogin
    }
  }, [_vm._v("已有账号!马上登录")])], 1)], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', {
    staticClass: "clearfix"
  }, [_c('span', [_vm._v("会员注册")])])])
}]}

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "contact-wrapper"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "concern"
  }, [_c('h2', [_c('Icon', {
    attrs: {
      "type": "heart"
    }
  }), _vm._v("  关注我们")], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(477),
      "title": "关注我们",
      "alt": "关注我们",
      "width": "150"
    }
  })])])]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("广告服务")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://gjypzc.taobao.com/"
    }
  }, [_vm._v("纸质入口")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("诚聘英才")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("用户指南")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("联系我们")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact"
  }, [_c('ol', [_c('li', {
    staticClass: "addr"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(475)
    }
  }), _vm._v("广州市白云区云城街机场路1718号631室\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "mobile"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(476)
    }
  }), _vm._v("\n                        020-37737622\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "wechat"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(183)
    }
  }), _vm._v("\n                        fairy4802004\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "qq"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(123)
    }
  }), _vm._v("\n                        3137597228\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "email"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(474)
    }
  }), _vm._v("\n                        gjypzc@qq.com\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright-text"
  }, [_c('p', [_vm._v("Copyright © 广州佳鑫医药科技有限公司")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "http://www.miitbeian.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("粤ICP备17013101号-1")])])])
}]}

/***/ }),

/***/ 492:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "close-window",
    on: {
      "click": _vm.closeLogin
    }
  }, [_c('Icon', {
    attrs: {
      "type": "close-round"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('h2', {
    staticClass: "clearfix"
  }, [_c('span', [_vm._v("会员登录")]), _vm._v(" "), _c('p', [_vm._v("还没有账号  "), _c('a', {
    on: {
      "click": _vm.reg
    }
  }, [_vm._v("立即注册")])])])]), _vm._v(" "), _c('Form', {
    ref: "login-form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "Phone"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doLogin($event)
      }
    },
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone", $$v)
      },
      expression: "form.phone"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doLogin($event)
      }
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "success",
      "long": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doLogin($event)
      }
    }
  }, [_vm._v(" 登 录 ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.forgot
    }
  }, [_vm._v("忘记密码？")])], 1), _vm._v(" "), _c('Form', [_c('header', {
    staticClass: "be divider"
  }, [_vm._v("\n                        第三方帐号登录\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "oauth clearfix"
  }, [_c('a', {
    staticClass: "qq",
    on: {
      "click": _vm.qq_login
    }
  }, [_c('i'), _vm._v(" "), _c('span', [_vm._v("QQ账号登录")])]), _vm._v(" "), _c('a', {
    staticClass: "wechat",
    on: {
      "click": _vm.weixin_login
    }
  }, [_c('i'), _vm._v(" "), _c('span', [_vm._v("微信账号登录")])])])])], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 493:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('headerView'), _vm._v(" "), _c('div', {
    staticClass: "main-whole"
  }, [_c('router-view')], 1), _vm._v(" "), _c('footerView'), _vm._v(" "), (_vm.login) ? _c('login') : _vm._e(), _vm._v(" "), (_vm.reg) ? _c('register') : _vm._e(), _vm._v(" "), (_vm.forgot) ? _c('forgot') : _vm._e(), _vm._v(" "), _c('affix')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getToken;
/* harmony export (immutable) */ __webpack_exports__["a"] = setToken;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);


var TokenKey = 'ccm-token';

function getToken() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(TokenKey);
}

function setToken(token) {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(TokenKey, token, { expires: 1 / 8 });
}

function removeToken() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(TokenKey);
}

/***/ })

},[234]);


// WEBPACK FOOTER //
// static/js/index.5c1ab3b6ed1ab0661fce.js